exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table td.fit[data-v-c5d57688], \n.table th.fit[data-v-c5d57688] {\n    white-space: nowrap;\n    width: 1%;\n}\n", ""]);

// exports
